import React from "react";

const Placeholder = ({ classNames = "", width = "w-full", height = "h-5", marginClass = 'mb-2' }) => {
  return (
    <div
      data-placeholder
      className={`overflow-hidden relative bg-gray-200 ${height} ${width} ${classNames} ${marginClass}`}
    />
  );
};

export default Placeholder;
